import { Box } from "@mui/joy";
import { SClose } from "styles/StyledMUI";
import IconButtonCTA from "../../../../common/IconButtonCTA";
import { colorTokens } from "../../../../../styles/globalStyles";

type SummaryActionsProps = {
  onClose: () => void;
};

export default function SummaryActions({ onClose }: SummaryActionsProps) {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        right: 0,
        width: "150px",
        height: "60px",
        backgroundColor: colorTokens.bg.sheetLight,
        border: "1px solid #E0E0E0",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "10px 0 0 0",
      }}
    >
      <IconButtonCTA ctaVariant="danger" aria-label="Fermer résumé" onClick={onClose}>
        <SClose />
      </IconButtonCTA>
    </Box>
  );
}
